import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import React, {Fragment, useEffect, useRef, useState} from 'react';
import {additionalData} from '../../../../store/reducers/additionalData';
import * as _find from 'lodash/find';
import _ from 'lodash';
import {addWorkflowStep, nextWorkflowStep, setWorkflow} from '../../../../store/reducers/workflow';
import moment from 'moment/moment';
import $ from 'jquery';
import div from '@mui/material/Paper';
import clsx from 'clsx';
import Grid from '@mui/material/Grid';
import AgyleBlockSwitch from '../../../../components/ui/switch/agyleBlockSwitch';
import {Drawer, FormLabel} from '@mui/material';
import ButtonGroup from '@mui/material/ButtonGroup';
import {hasOneOfPermission, hasPermission, Permissions, user} from '../../../../store/reducers/user';
import MessageBox from '../../../../util/messageBox';
import {
    getFullObsName,
    getObsDisplayValues,
    mapObservationFromAPI,
    mapObservationToAPI,
    obsStatuses,
    obsTypes,
    riskLevels,
} from './obsUtils';
import ObsNeuroEyesOpen, {renderObsNeuroEyesOpenSectionScore} from './components/obsNeuroEyesOpen';
import ObsNeuroBestVerbalResponse, {
    renderNeuroBestVerbalResponseSectionScore,
} from './components/obsNeuroBestVerbalResponse';
import ObsNeuroBestMotorResponse, {
    renderNeuroBestMotorResponseSectionScore,
} from './components/obsNeuroBestMotorResponse';
import ObsRespiration from './components/obsRespiration';
import ObsAirOxygen from './components/obsAirOxygen';
import ObsBloodPressure from './components/obsBloodPressure';
import ObsRespiratoryDistress from './components/obsRespiratoryDistress';
import ObsRespiratoryDistressWheezing from './components/obsRespiratoryDistressWheezing';
import ObsStridor from './components/obsStridor';
import ObsApnoea from './components/obsApnoea';
import ObsPulseRate from './components/obsPulseRate';
import ObsConsciousness from './components/ObsConsciousness';
import ObsCRT from './components/obsCRT';
import ObsTemperature from './components/obsTemperature';
import ObsPainScore from './components/obsPainScore';
import ObsSpo2 from './components/obsSpo2';
import ObsGlucose from './components/obsGlucose';
import ObsNeuroPupils from './components/obsNeuroPupils';
import ObsNeuroLimbMovementArms from './components/obsNeuroLimbMovementArms';
import ObsNeuroLimbMovementLegs from './components/obsNeuroLimbMovementLegs';
import ObsScore from './components/obsScore';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import AgyleAccordion from '../../../../components/ui/accordion/agyleAccordion';
import {isSpecialSmallDeviceDetect} from '../../../../util/isSpecialSmallDeviceDetect';
import ObsRetrospective from './components/obsRetrospective';
import {SepsisPathwayStatus} from '../../sepsis/sepsisUtil';
import {getConfig} from '../../../../util/configUtil';
import API from '../../../../app/api';
import {setSnackbar} from '../../../../store/reducers/globals';
import Formatter from '../../../../util/formatter';
import Notes from '../../../../util/notes';
import {addNoteForPatient} from '../../../../store/reducers/notes';
import {ctxObsPrevStats, ctxObsSettings} from '../../../../store/reducers/patientContext';
import {WORKFLOW_OPTIONS} from '../../../../util/workflowUtil';
import {obsFromForms, setObsIdToFormAdd} from '../../../../store/reducers/formsAdditionalHelper';
import {obsStyles} from './obsStyle';
import {refreshPatient} from '../../../../store/reducers/patient';

const initData = (type) => {
    // AGL-722 - 001. Available Parameters for PEWS Observations
    // AGL-723 - 001. Available Parameters for NEWS2 Observations

    return {
        type: type,
        startedDate: moment(),
        completedDate: null,
        completedByFullName: window?.auth?.tokenParsed?.name,
        completedBy: window?.auth?.tokenParsed?.preferred_username,
        status: obsStatuses.new,
        canceledDate: null,
        canceledByFullName: null,
        canceledBy: null,
        totalScore: 0,
        nextObs: null,
        nextObsDate: null,
        nextObsStatus: obsStatuses.new,
        nextObsReason: '',
        clinicalResponse: null,
        riskLevel: null,
        prevTotalScore: null,
        prevRiskLevel: null,
        extraOption1: null,
        extraOption1Reason: null,
        extraOption2: null,
        extraOption3: null,
        extraOption3Reason: null,
        extraOption4: null,
        extraOption4Reason: null,
        ambulanceObs: false,
        respiration: {
            status: obsStatuses.new,
            score: 0,
            accepted: false,
            acceptDate: null,
            breaths: undefined,
        },
        distress: {
            status: obsStatuses.new,
            score: 0,
            accepted: false,
            acceptDate: null,
            distress: null,
        },
        wheezing: {
            status: obsStatuses.new,
            score: 0,
            accepted: false,
            acceptDate: null,
            wheezing: null,
        },
        stridor: {
            status: obsStatuses.new,
            score: 0,
            accepted: false,
            acceptDate: null,
            stridor: null,
        },
        apnoea: {
            status: obsStatuses.new,
            score: 0,
            accepted: false,
            acceptDate: null,
            apnoea: null,
        },
        airOxygen: {
            status: obsStatuses.new,
            score: 0,
            accepted: false,
            acceptDate: null,
            airType: 'room',
            device: null,
            inspiredOxygen: undefined,
        },
        spo2scale: {
            status: obsStatuses.new,
            score: 0,
            accepted: false,
            acceptDate: null,
            hypercapnic: false,
            spo2scale: undefined,
        },
        bloodPressure: {
            status: obsStatuses.new,
            score: 0,
            accepted: false,
            acceptDate: null,
            systolicPressure: undefined,
            diastolicPressure: undefined,
            arm: 'left',
            optionalBP: false,
            optionalSystolicPressure: undefined,
            optionalDiastolicPressure: undefined,
            optionalArm: 'left',
        },
        pulseRate: {
            status: obsStatuses.new,
            score: 0,
            accepted: false,
            acceptDate: null,
            pulseRate: undefined,
            pulseType: undefined,
        },
        consciousness: {
            status: obsStatuses.new,
            score: 0,
            accepted: false,
            acceptDate: null,
            consciousnessLevel: null,
        },
        temperature: {
            status: obsStatuses.new,
            score: 0,
            accepted: false,
            acceptDate: null,
            temperature: undefined,
        },
        painScore: {
            status: obsStatuses.new,
            score: 0,
            accepted: false,
            acceptDate: null,
            painScore: undefined,
        },
        crt: {
            status: obsStatuses.new,
            score: 0,
            accepted: false,
            acceptDate: null,
            crt: undefined,
        },
        eyesOpen: {
            status: obsStatuses.new,
            score: undefined,
            accepted: false,
            acceptDate: null,
            eyesOpenLevel: null,
            eyesClosedBySwelling: false,
        },
        bestVerbalResponse: {
            status: obsStatuses.new,
            score: undefined,
            accepted: false,
            acceptDate: null,
            response: null,
            tracheostomy: false,
        },
        bestMotorResponse: {
            status: obsStatuses.new,
            score: undefined,
            accepted: false,
            acceptDate: null,
            response: null,
        },
        pupils: {
            status: obsStatuses.new,
            score: undefined,
            accepted: false,
            acceptDate: null,
            reactionLeft: null,
            sizeLeft: undefined,
            closedLeft: false,
            reactionRight: null,
            sizeRight: undefined,
            closedRight: false,
        },
        limbMovementArms: {
            status: obsStatuses.new,
            score: undefined,
            accepted: false,
            acceptDate: null,
            movement: null,
            optionalArm: false,
            arm: null,
            secondMovement: null,
            secondArm: null,
        },
        limbMovementLegs: {
            status: obsStatuses.new,
            score: undefined,
            accepted: false,
            acceptDate: null,
            movement: null,
            optionalLeg: false,
            leg: null,
            secondMovement: null,
            secondLeg: null,
        },
        glucose: {
            status: obsStatuses.new,
            score: undefined,
            accepted: false,
            acceptDate: null,
            glucose: undefined,
            ketones: undefined,
        },
    };
};

const obsMapper = {
    news: [
        ['retro', 'respiration', 'airOxygen', 'spo2scale'],
        ['bloodPressure', 'pulseRate'],
        ['consciousness', 'temperature'],
        ['painScore', 'glucose'],
    ],
    pews: [
        ['retro', 'respiration', 'airOxygen'],
        ['distress', 'wheezing'],
        ['stridor', 'apnoea'],
        ['spo2scale', 'bloodPressure'],
        ['pulseRate', 'consciousness'],
        ['crt', 'temperature', 'painScore', 'glucose'],
    ],
    neuro: [
        ['retro', 'eyesOpen', 'bestVerbalResponse'],
        ['bestMotorResponse', 'pupils'],
        ['limbMovementArms', 'limbMovementLegs', 'glucose'],
    ],
};

function Observation(props) {
    const dispatch = useDispatch();
    const classes = obsStyles();
    const {t} = useTranslation();
    const isSmallDevice = isSpecialSmallDeviceDetect();

    // Configs
    const newRiskAssessment = getConfig('observations.newRiskAssessment');
    const safetyListButtonInObs = getConfig('safetyListButtonInObs');
    const retrospective = getConfig('observations.retrospective');
    const overHour = getConfig('observations.overHour');

    const formFormsOpened = useSelector(obsFromForms);
    const prevObsStats = useSelector(ctxObsPrevStats);

    const obsSettings = useSelector(ctxObsSettings);
    const type = props.neuroObs ? obsTypes.neuro : obsSettings.obsType;
    const ageRangeYears = props.neuroObs ? obsSettings.neuroAgeRange : obsSettings.obsAgeRange;

    // User
    const userObject = useSelector(user);
    const userFullName = Formatter.formatUserFullName(userObject);
    const canEditSepsis = dispatch(hasOneOfPermission([Permissions.AGYLE_CAN_MANAGE_SEPSIS]));

    const [localValue, setLocalValue] = useState(() => initData(type));
    const [disableAction, setDisableAction] = useState(false);

    const [allAccepted, setAllAccepted] = useState(false);
    const [anyAccepted, setAnyAccepted] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState('');
    const [confirmAction, setConfirmAction] = useState(() => {
    });
    const [acceptDisabled, setAcceptDisabled] = useState(false);
    const [isNotTestable, setIsNotTestable] = useState(false);

    const [openSafetyChecklistAfterObs, setOpenSafetyChecklistAfterObs] = useState(safetyListButtonInObs);
    const [openNeuroAfterObs, setOpenNeuroAfterObs] = useState(false);

    const [iPodStep, setIpodStep] = useState(0);
    const [ipodView, setIpodView] = useState(props.ipod);
    const selectedSectionName = useRef('');
    const container = document.getElementById('obs-dialog');
    const [mobileOpen, setMobileOpen] = useState(false);
    const [errorRetro, setErrorRetro] = useState(null);
    const [observations, setObservations] = useState([]);

    useEffect(() => {
        const type = props.neuroObs ? obsTypes.neuro : obsSettings.obsType;
        API.getFullObservations(props.patient, type)
            .then((result) => {
                let obs = [];
                _.forEach(result, (apiObs) => {
                    obs.push(mapObservationFromAPI(apiObs, true));
                });

                setObservations(obs);
            })
            .catch((error) => {
                console.error('Observations.API.getObservations: ', error);
            });
    }, [obsSettings]);

    const obsItemList = {
        retro: {
            component: ObsRetrospective,
            expanded: true,
            disabled: !retrospective,
            updateRoot: true,
            props: {
                patient: props.patient,
                observations: observations,
            },
        },
        respiration: {
            component: ObsRespiration,
            expanded: true,
        },
        airOxygen: {
            component: ObsAirOxygen,
            expanded: true,
        },
        bloodPressure: {
            component: ObsBloodPressure,
            expanded: true,
        },
        distress: {
            component: ObsRespiratoryDistress,
            expanded: true,
        },
        wheezing: {
            component: ObsRespiratoryDistressWheezing,
            expanded: true,
        },
        stridor: {
            component: ObsStridor,
            expanded: true,
        },
        apnoea: {
            component: ObsApnoea,
            expanded: true,
        },
        pulseRate: {
            component: ObsPulseRate,
            expanded: true,
        },
        consciousness: {
            component: ObsConsciousness,
            expanded: true,
        },
        crt: {
            component: ObsCRT,
            expanded: true,
        },
        temperature: {
            component: ObsTemperature,
            expanded: true,
        },
        painScore: {
            component: ObsPainScore,
            expanded: true,
        },
        spo2scale: {
            component: ObsSpo2,
            expanded: true,
            props: {
                airType: getAirType(),
            },
        },
        glucose: {
            component: ObsGlucose,
            expanded: true,
        },
        eyesOpen: {
            component: ObsNeuroEyesOpen,
            expanded: true,
        },
        bestVerbalResponse: {
            component: ObsNeuroBestVerbalResponse,
            expanded: true,
        },
        bestMotorResponse: {
            component: ObsNeuroBestMotorResponse,
            expanded: true,
        },
        pupils: {
            component: ObsNeuroPupils,
            expanded: true,
        },
        limbMovementArms: {
            component: ObsNeuroLimbMovementArms,
            expanded: true,
        },
        limbMovementLegs: {
            component: ObsNeuroLimbMovementLegs,
            expanded: true,
        },
    };

    const [observationItemsList, setObservationItemsList] = useState(obsItemList);

    useEffect(() => {
        if (props.onCustomButtons) {
            const btn = [];
            if (safetyListButtonInObs) {
                btn.push(
                    <div className={classes.divRow} style={{marginLeft: 10, marginTop: 5}}>
                        <AgyleBlockSwitch
                            onChange={setOpenSafetyChecklistAfterObs}
                            value={openSafetyChecklistAfterObs}
                            size="small"
                        />
                        <FormLabel style={{marginLeft: 5}}>
                            {t('Open PSC after OBS')}
                        </FormLabel>
                    </div>,
                );
            }
            if (safetyListButtonInObs && type !== obsTypes.neuro) {
                btn.push(
                    <div className={classes.divRow} style={{marginLeft: 10, marginTop: 5}}>
                        <AgyleBlockSwitch
                            onChange={setOpenNeuroAfterObs}
                            value={openNeuroAfterObs}
                            size="small"
                        />
                        <FormLabel style={{marginLeft: 5}}>
                            {t('Open Neuro after OBS')}
                        </FormLabel>
                    </div>,
                );
            }

            props.onCustomButtons(btn);
        }
        if (props.onSubmitFunction) {
            props.onSubmitFunction(onSaveObs);
        }
        if (props.onDisableSubmit) {
            props.onDisableSubmit(acceptDisabled || disableAction || errorRetro);
        }
        if (props.onHideSubmit) {
            // props.onHideSubmit();
        }
        if (props.onCustomSubmitText) {
            // props.onCustomSubmitText();
        }
    }, [localValue, allAccepted, acceptDisabled, disableAction, type, anyAccepted, errorRetro, safetyListButtonInObs, openNeuroAfterObs, openSafetyChecklistAfterObs]);

    // It is needed to update airType
    useEffect(() => {
        setObservationItemsList(prevState => ({
            ...prevState,
            spo2scale: {
                ...prevState?.spo2scale,
                props: {
                    airType: getAirType(),
                },
            },
        }));
    }, [localValue.airOxygen?.airType]);

    // It is needed to update patient and array of observations
    useEffect(() => {
        setObservationItemsList(prevState => ({
            ...prevState,
            retro: {
                ...prevState?.retro,
                props: {
                    patient: props.patient,
                    observations: observations,
                },
            },
        }));
    }, [props.patient, observations]);

    const obsSections = {
        retro: {
            description: t('Assessed Time'),
            obsTypes: [obsTypes.news, obsTypes.pews, obsTypes.neuro],
            hideScore: true,
        },
        respiration: {
            description: t('Respiratory Rate'),
            obsTypes: [obsTypes.news, obsTypes.pews],
            hideScore: type === obsTypes.neuro,
        },
        airOxygen: {
            description: t('Inspired O₂%'),
            obsTypes: [obsTypes.news, obsTypes.pews],
            hideScore: type === obsTypes.neuro,
        },
        distress: {
            description: t('Respiratory Distresses'),
            obsTypes: [obsTypes.pews],
        },
        wheezing: {
            description: t('Respiratory Distress Wheezing'),
            obsTypes: [obsTypes.pews],
            hideScore: true,
        },
        stridor: {
            description: t('Stridor'),
            obsTypes: [obsTypes.pews],
            hideScore: true,
        },
        apnoea: {
            description: t('Apnoea'),
            obsTypes: [obsTypes.pews],
            hideScore: true,
        },
        spo2scale: {
            description: t('SpO₂'),
            obsTypes: [obsTypes.news, obsTypes.pews],
            hideScore: type === obsTypes.neuro,
        },
        bloodPressure: {
            description: t('Blood Pressure'),
            obsTypes: [obsTypes.news, obsTypes.pews],
            hideScore: type === obsTypes.neuro,
        },
        pulseRate: {
            description: t('Heart Rate'),
            obsTypes: [obsTypes.news, obsTypes.pews],
            hideScore: type === obsTypes.neuro,
        },
        consciousness: {
            description: t('Consciousness Level'),
            obsTypes: [obsTypes.news, obsTypes.pews],
            hideScore: type === obsTypes.pews,
        },
        crt: {description: t('CRT'), obsTypes: [obsTypes.pews]},
        temperature: {
            description: t('Temperature'),
            obsTypes: [obsTypes.news, obsTypes.pews],
            hideScore: type === obsTypes.pews || type === obsTypes.neuro,
        },
        painScore: {
            description: t('Pain Score'),
            obsTypes: [obsTypes.news, obsTypes.pews],
            hideScore: true,
        },
        eyesOpen: {
            description: t('Eye opening'),
            obsTypes: [obsTypes.neuro],
            // renderScore: ObsNeuroEyesOpen.renderSectionScore,
            renderScore: renderObsNeuroEyesOpenSectionScore,
        },
        bestVerbalResponse: {
            description: t('Best Verbal Response'),
            obsTypes: [obsTypes.neuro],
            // renderScore: ObsNeuroBestVerbalResponse.renderSectionScore,
            renderScore: renderNeuroBestVerbalResponseSectionScore,
        },
        bestMotorResponse: {
            description: t('Best Motor Response'),
            obsTypes: [obsTypes.neuro],
            // renderScore: ObsNeuroBestMotorResponse.renderSectionScore,
            renderScore: renderNeuroBestMotorResponseSectionScore,
        },
        pupils: {
            description: t('Pupils'),
            obsTypes: [obsTypes.neuro],
            hideScore: true,
        },
        limbMovementArms: {
            description: t('Limb Movement - Arms'),
            obsTypes: [obsTypes.neuro],
            hideScore: true,
        },
        limbMovementLegs: {
            description: t('Limb Movement - Legs'),
            obsTypes: [obsTypes.neuro],
            hideScore: true,
        },
        glucose: {
            description: t('Blood Glucose'),
            obsTypes: [obsTypes.news, obsTypes.pews, obsTypes.neuro],
            hideScore: true,
        },
    };

    useEffect(() => {
        setIpodStep(0);
        setLocalValue(props.value || initData(type));
        setDisableAction(false);
    }, [props.value, type, ageRangeYears]);

    const patientAddData = useSelector(additionalData);
    const incompleteSepsisPath = patientAddData && patientAddData.other && patientAddData.other.sepsisPathways
        ? _find(patientAddData.other.sepsisPathways, ['statusObj', SepsisPathwayStatus.INCOMPLETE])
        : null;

    const getRiskLevelIndex = (level) => _.findIndex(Object.keys(riskLevels), rl => rl === level);

    const getNewLocalValue = (localValue, updateValue) => {
        // console.log("updateLocalValue.updateValue", updateValue);
        // console.log("updateLocalValue.localValue", localValue);
        const newValue = {...localValue, ...updateValue};

        const paramsToSet = {};
        let atLeastOneHigh = false;
        let atLeastOneNotRecorded = false;
        let atLeastOneNotTestable = false;
        let newRiskLevel = (newRiskAssessment && type === obsTypes.pews) ? riskLevels.continue : riskLevels.none;
        let accepted = true;
        let acceptedCount = 0;
        let consciousness = false;

        let totalScore = 0;
        _.forEach(Object.keys(obsSections), (sectionName) => {
            if (sectionName === 'retro') return;

            let section = obsSections[sectionName];
            if (section.hasOwnProperty('obsTypes') && !_.includes(section.obsTypes, type)) return;

            let obs = newValue[sectionName];
            let obsStatus = obs.status || obsStatuses.new;
            let obsScore = obs.score || 0;
            totalScore += obsScore;

            if (!obs.accepted && sectionName !== 'glucose') accepted = false;
            else acceptedCount++;

            if (obsScore >= 3) atLeastOneHigh = true;
            if (obsStatus !== obsStatuses.new && obsStatus !== obsStatuses.completed) atLeastOneNotRecorded = true;

            // Set not testable if either a 'C' or 'T' is entered
            if (newValue.type === 'neuro') {
                if (obsStatus === obsStatuses.completed && typeof obs.score === 'undefined') {
                    atLeastOneNotTestable = true;
                }

                if (sectionName === 'pupils') {
                    if (obs?.closedLeft || obs?.closedRight) {
                        atLeastOneNotTestable = true;
                    }
                }
            }
            if (sectionName === 'consciousness') {
                consciousness = !_.isUndefined(obs?.consciousnessLevel?.id) && obs?.consciousnessLevel?.id !== 'alert';
            }
        });

        if (type === obsTypes.news) {
            if (newRiskAssessment) {
                // First select risk level by score
                if (totalScore >= 7) {
                    newRiskLevel = riskLevels.emergency;
                } else if (totalScore > 4 && totalScore < 7) {
                    newRiskLevel = riskLevels.medium;
                } else if (totalScore > 2 && totalScore < 4) {
                    newRiskLevel = riskLevels.low;
                } else {
                    newRiskLevel = riskLevels.continue;
                }

                paramsToSet.extraOption1 = atLeastOneHigh;
                paramsToSet.extraOption1Disabled = atLeastOneHigh;
                paramsToSet.extraOption2 = totalScore >= 5;
                paramsToSet.extraOption2Disabled = totalScore >= 5;

                if (newValue.extraOption1 && getRiskLevelIndex(newRiskLevel) < getRiskLevelIndex(riskLevels.low)) {
                    newRiskLevel = riskLevels.low;
                }

                if (newValue.extraOption2 && getRiskLevelIndex(newRiskLevel) < getRiskLevelIndex(riskLevels.medium)) {
                    newRiskLevel = riskLevels.medium;
                }

                if (newValue.extraOption3 && getRiskLevelIndex(newRiskLevel) < getRiskLevelIndex(riskLevels.emergency)) {
                    newRiskLevel = riskLevels.emergency;
                }
            } else {
                if (totalScore >= 9) {
                    newRiskLevel = riskLevels.high;

                    if (atLeastOneHigh || newValue?.painScore?.painScore >= 5) {
                        paramsToSet.extraOption1 = true;
                        paramsToSet.extraOption1Disabled = true;
                    }
                } else if (totalScore >= 7 && totalScore < 9) {
                    newRiskLevel = riskLevels.medium;
                    paramsToSet.extraOption2 = true;
                    paramsToSet.extraOption2Disabled = true;

                    if (atLeastOneHigh || newValue?.painScore?.painScore >= 5) {
                        paramsToSet.extraOption1 = true;
                        paramsToSet.extraOption1Disabled = true;
                    }
                } else if (totalScore >= 5 && totalScore < 7) {
                    newRiskLevel = riskLevels.mediumLow;
                    paramsToSet.extraOption2 = true;
                    paramsToSet.extraOption2Disabled = true;

                    if (atLeastOneHigh || newValue?.painScore?.painScore >= 5) {
                        paramsToSet.extraOption1 = true;
                        paramsToSet.extraOption1Disabled = true;
                    }
                } else if (newValue.extraOption2 && !localValue.extraOption2Disabled) {
                    newRiskLevel = riskLevels.mediumLow;
                } else if (atLeastOneHigh || newValue?.painScore?.painScore >= 5) {
                    newRiskLevel = riskLevels.low;
                    paramsToSet.extraOption1 = true;
                    paramsToSet.extraOption1Disabled = true;
                } else if (newValue.extraOption1 && !localValue.extraOption1Disabled) {
                    newRiskLevel = riskLevels.low;
                    if (localValue.extraOption2Disabled) {
                        paramsToSet.extraOption2 = null;
                    }
                    paramsToSet.extraOption2Disabled = false;
                } else {
                    newRiskLevel = riskLevels.none;
                    if (localValue.extraOption1Disabled) {
                        paramsToSet.extraOption1 = null;
                    }
                    paramsToSet.extraOption1Disabled = false;
                    if (localValue.extraOption2Disabled) {
                        paramsToSet.extraOption2 = null;
                    }
                    paramsToSet.extraOption2Disabled = false;
                }
            }
        } else if (type === obsTypes.pews) {
            // if (accepted) {
            if (newRiskAssessment) {
                paramsToSet.extraOption2Disabled = true;

                // First select risk level by score
                if (totalScore >= 13) {
                    newRiskLevel = riskLevels.emergency;
                } else if (totalScore >= 9 && totalScore < 13) {
                    newRiskLevel = riskLevels.high;
                } else if (totalScore >= 5 && totalScore < 9) {
                    newRiskLevel = riskLevels.medium;
                } else if (totalScore >= 2 && totalScore < 5) {
                    newRiskLevel = riskLevels.low;
                }

                // if nursing instinct is selected
                if (newValue?.extraOption1 && newValue?.extraOption1Reason) {
                    const level = newValue?.extraOption1Reason?.riskLevel;
                    if (getRiskLevelIndex(newRiskLevel) < getRiskLevelIndex(level)) newRiskLevel = level;
                }

                // if family Concern is selected
                if (newValue?.extraOption4 && newValue?.extraOption4Reason) {
                    const level = newValue?.extraOption4Reason?.riskLevel;
                    if (getRiskLevelIndex(newRiskLevel) < getRiskLevelIndex(level)) newRiskLevel = level;
                }

                // if sepsis suspected is selected
                if (newValue?.extraOption3 && getRiskLevelIndex(newRiskLevel) < getRiskLevelIndex(riskLevels.high)) {
                    newRiskLevel = riskLevels.high;
                }

                // Check if consciousness level is diffrent then alerted
                if (newValue?.consciousness?.consciousnessLevel && newValue?.consciousness?.consciousnessLevel?.id !== 'alert') {
                    const level = newValue?.consciousness?.consciousnessLevel?.id;
                    paramsToSet.extraOption2 = true;

                    if (level === 'respondsToVoice') {
                        if (getRiskLevelIndex(newRiskLevel) < getRiskLevelIndex(riskLevels.high)) newRiskLevel = riskLevels.high;
                    } else {
                        if (getRiskLevelIndex(newRiskLevel) < getRiskLevelIndex(riskLevels.emergency)) newRiskLevel = riskLevels.emergency;
                    }
                } else {
                    paramsToSet.extraOption2 = false;
                }
            } else {
                if (accepted) {
                    // Old Risk Assessments
                    if (atLeastOneHigh || newValue?.painScore?.painScore >= 5 || (totalScore >= 1 && totalScore < 5)) {
                        paramsToSet.extraOption1 = true;
                        paramsToSet.extraOption1Disabled = true;
                        newRiskLevel = riskLevels.medium;
                    }

                    if (consciousness || totalScore >= 5) {
                        paramsToSet.extraOption2 = true;
                        paramsToSet.extraOption2Disabled = true;
                        newRiskLevel = riskLevels.high;
                    }
                } else {
                    paramsToSet.extraOption1 = undefined;
                    paramsToSet.extraOption1Disabled = false;
                    paramsToSet.extraOption2 = undefined;
                    paramsToSet.extraOption2Disabled = false;
                }
            }
            // }
        } else {
            newRiskLevel = riskLevels.none;
        }

        if (incompleteSepsisPath) {
            paramsToSet.extraOption3Disabled = true;
            paramsToSet.extraOption3 = true;
        }

        let newStatus;
        if (accepted) {
            if (atLeastOneNotRecorded) {
                newStatus = obsStatuses.notRecorded;
            } else if (atLeastOneNotTestable) {
                newStatus = obsStatuses.notTestable;
            } else {
                newStatus = obsStatuses.completed;
            }
        } else {
            newStatus = obsStatuses.partial;
        }

        const value = {
            ...newValue,
            ...paramsToSet,
            totalScore,
            riskLevel: newRiskLevel,
            status: newStatus,
        };
        // setLocalValue(value);
        setAllAccepted(accepted);
        setAnyAccepted(acceptedCount > 0);
        setIsNotTestable(atLeastOneNotTestable);

        return value;
    };

    const updateLocalValue = (updateValue) => {
        setLocalValue((localValue) => getNewLocalValue(localValue, updateValue));
    };

    const onConfirmCancel = () => {
        setConfirmDialog(false);
        if (!formFormsOpened) dispatch(nextWorkflowStep());
        if (props.onCancel) props.onCancel();
    };

    const manageAfterSave = (obs, openSafetyChecklistAfterObs, openNeuroAfterObs) => {
        let queueTmp = [];
        if (openNeuroAfterObs) queueTmp.push(WORKFLOW_OPTIONS.NEURO_OBSERVATION);
        if (openSafetyChecklistAfterObs) queueTmp.push(WORKFLOW_OPTIONS.SAFETY_CHECKLIST);

        dispatch(addWorkflowStep(queueTmp));

        if (obs.extraOption3 && !incompleteSepsisPath && canEditSepsis) {
            dispatch(setWorkflow({
                type: formFormsOpened ? WORKFLOW_OPTIONS.SEPSIS_AFTER_TRIAGE : WORKFLOW_OPTIONS.SEPSIS,
                data: {
                    obsData: obs.startedDate.toISOString(),
                },
            }));
        } else if (!formFormsOpened) {
            dispatch(nextWorkflowStep());
        }
    };

    const saveNotes = (obs) => {
        // build a note content
        const type = obs.type || obsTypes.news;
        const obsDisplayValues = getObsDisplayValues(type);
        const note = Notes.getObservationNote(getFullObsName(type), type, obsDisplayValues, obs);

        // window.auth.loadUserInfo().then(userInfo => {
        dispatch(addNoteForPatient(props.patient.patient.__id, {
            note: note,
            noteType: 'obs',
            patientsInWardsRef: [props.patient.__id],
            referenceId: obs.__id,
            episodeId: props.patient?.admission?.consultantEpisodeId || null,
        }, props.patient.__id));
        // });
    };

    const modifyLastObs = (response) => {
        if ((response.status === 'completed' || response.status === 'notRecorded')
            && (response.investigation === 'pews' || response.investigation === 'news')) {
            props.modifyLastObs(response);
        }
    };

    const onSaveObsApi = async (value, openSafetyChecklistAfterObs, openNeuroAfterObs) => {
        let ptObject = await dispatch(refreshPatient(props.patient));

        value = {
            ...value,
            completedByFullName: userFullName,
            completedBy: userObject.userName,
            attendanceCustomId: ptObject.admission.attendanceCustomId,
            patientInWardId: ptObject.__id,
        };
        let apiObservation = mapObservationToAPI(value);
        API.saveObservation({
                patientId: ptObject.patient.__id,
                observation: apiObservation,
            })
            .then((apiObs) => {
                let obs = mapObservationFromAPI(apiObs, true);
                value.__id = obs.__id;

                // Replace last observation in patient view
                modifyLastObs(apiObs);

                if (formFormsOpened) {
                    dispatch(setObsIdToFormAdd(obs?.__id));
                }

                saveNotes(value);
                let data = [
                    {
                        'metadata.lastObs': {
                            obs_id: obs.__id,
                            date: moment().toISOString(),
                        },
                    },
                ];

                if (obs.investigation === obsTypes.neuro && obs.nextObsDate) {
                    data.push({
                        'metadata.nextNeuroObs': {
                            obs_id: obs.__id,
                            date: moment().toISOString(),
                            nextObs: obs.nextObsDate,
                        },
                    });
                } else if (obs.investigation === obsTypes.neuro && ptObject?.metadata.nextNeuroObs?.obs_id !== obs.__id) {
                    data.push({
                        'metadata.nextNeuroObs': null,
                    });
                }

                API.updatePatientInWard(ptObject.__id, data)
                    .then((response) => {
                        manageAfterSave(obs, openSafetyChecklistAfterObs, openNeuroAfterObs);

                        // console.log("Observations.API.updatePatientInWard", response);
                    })
                    .catch((error) => {
                        console.error(
                            'Observations.API.updatePatientInWard: ',
                            error,
                        );
                    });
            })
            .catch((error) => {
                if (props.ipod) {
                    dispatch(setSnackbar({
                        type: 'error',
                        message: 'An error occurred while trying to save observations.',
                    }));
                }
                console.error('Observations.API.saveObservation: ', error);
            });
    };

    const saveObs = () => {
        setDisableAction(true);
        setConfirmDialog(false);
        let value = {
            ...localValue,
            completedDate: moment(),
            prevTotalScore: prevObsStats.totalScore,
            prevRiskLevel: prevObsStats.riskScore,
            nextObsDate:
                localValue.status === obsStatuses.partial
                    ? prevObsStats.obsDate
                    : localValue.nextObsDate,
        };
        if (allAccepted) {
            // value.status = obsStatuses.completed;
        } else if (anyAccepted) {
            // value.status = obsStatuses.partial;

            _.forEach(Object.keys(obsSections), (sectionName) => {
                let section = obsSections[sectionName];
                // if (section.hasOwnProperty("obsTypes") && !_.includes(section.obsTypes, type)) {
                //     return;
                // }
                if (sectionName in value) {
                    let obs = value[sectionName];
                    if (obs && !obs.accepted) {
                        // AGL-917 - 002. Observations Not Recorded (NR)
                        obs.status = obsStatuses.notRecorded;
                    }
                }
            });
        }

        setLocalValue(value);
        if (props.onSave) props.onSave(value, openSafetyChecklistAfterObs, openNeuroAfterObs);
        if (props.onChange) onSaveObsApi(value, openSafetyChecklistAfterObs, openNeuroAfterObs);
        setOpenSafetyChecklistAfterObs(false);
        setOpenNeuroAfterObs(false);
        if (props._onForceClose) props._onForceClose();
    };

    const onSaveObs = () => {
        if (allAccepted) {
            saveObs();
        } else if (anyAccepted || type === obsTypes.pews || type === obsTypes.neuro) {
            let msg = t('Are you sure you want to save incomplete OBS entry?<br />All non-accepted observations will be mark as \'Not Recorded\':<br /><ul>');

            _.forEach(Object.keys(obsSections), (sectionName) => {
                let section = obsSections[sectionName];
                if (section.hasOwnProperty('obsTypes') && !_.includes(section.obsTypes, type)) return;

                let obs = localValue[sectionName];
                if (obs && !obs.accepted) {
                    msg += `<li>${section.description}</li>`;
                }
            });
            msg += '</ul>';

            setConfirmMessage(msg);
            setConfirmAction(() => saveObs);
            setConfirmDialog(true);
            return false;
        }
    };

    const showCancelDialog = () => {
        setConfirmMessage(t('Are you sure you want to cancel this OBS entry?'));
        setConfirmAction(() => onConfirmCancel);
        setConfirmDialog(true);
    };

    const changeIpodPageTo = (sectionName) => {
        let sectionSelected = false;

        obsMapper[type].forEach((obsList, index) => {
            obsList.forEach((item) => {
                if (item === sectionName) {
                    sectionSelected = true;
                    if (index === iPodStep)
                        scrollToIpodSection(sectionName);
                    else {
                        selectedSectionName.current = sectionName;
                        setIpodStep(index);
                    }
                }
            });
        });
        if (!sectionSelected) setIpodStep(obsMapper[type].length);
    };

    const scrollToSection = (sectionName) => {
        const elementToNavigate = $('#' + sectionName);
        if (elementToNavigate && elementToNavigate.length > 0) {
            const scrollDomObj = $('.obs-scrollbar');
            if (scrollDomObj) {
                scrollDomObj[0].scrollTop = elementToNavigate.position().top + scrollDomObj[0].scrollTop;
            }
        }
    };

    const scrollToIpodSection = (sectionName) => {
        const scrollDomObj = $('#scroll-dialog-content');
        let realTop = 0;
        if (scrollDomObj) {
            if (sectionName) {
                const elementToNavigate = $('#' + sectionName);
                realTop = elementToNavigate.position().top;
                selectedSectionName.current = '';
            }
            scrollDomObj.scrollTop(realTop);
        }
    };

    useEffect(() => {
        scrollToIpodSection(selectedSectionName.current);
    }, [iPodStep]);

    const openSection = (sectionName) => {
        setObservationItemsList(prevState => ({
            ...prevState,
            [sectionName]: {
                ...prevState[sectionName],
                expanded: true,
            },
        }));
    };

    const onSectionClick = (sectionName) => {
        setMobileOpen(false);
        openSection(sectionName);

        if (ipodView)
            changeIpodPageTo(sectionName);
        else
            scrollToSection(sectionName);

    };

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const drawerWidth = 240;

    const obsMenuList = (
        <div className={'scroll-normal-white'}>
            {Object.keys(obsSections).map((sectionName, index) => {
                if (observationItemsList?.[sectionName]?.disabled) return null;

                const section = obsSections[sectionName];
                if (section.hasOwnProperty('obsTypes') && !_.includes(section.obsTypes, type)) return null;

                let status = localValue[sectionName]?.status || obsStatuses.new;
                let score = localValue[sectionName]?.score;
                let accepted = localValue[sectionName]?.accepted;
                let obs = localValue[sectionName];

                return (
                    <Fragment key={sectionName}>
                        <div
                            onClick={() => onSectionClick(sectionName)}
                            className={clsx([classes.sectionItem, accepted && classes.sectionItemSelected])}
                        >
                            <div className={classes.sectionLabel}>
                                {obsSections[sectionName].description}
                            </div>
                            {!section.hideScore && (
                                <>
                                    {section.renderScore ? (
                                        section.renderScore({classes, t, section, obs, status, score, accepted})
                                    ) : (
                                        status !== obsStatuses.new && (
                                            <div
                                                className={clsx([classes.sectionScore, `score${score}`, accepted && classes.sectionScoreSelected])}
                                            >
                                                {status === obsStatuses.new || status === obsStatuses.completed ? score : null}
                                                {status === obsStatuses.patientCondition ? `${score}+` : null}
                                                {status === obsStatuses.notRecorded ? 'NR' : null}
                                                {status === obsStatuses.patientRefused ? 'PR' : null}
                                                {status === obsStatuses.equipment ? 'EQ' : null}
                                            </div>
                                        )
                                    )}
                                </>
                            )}
                        </div>
                    </Fragment>
                );
            })}

            <div
                onClick={() => onSectionClick('score')}
                className={clsx([classes.sectionItem])}
            >
                <div className={classes.sectionLabel}>
                    {type === obsTypes.news ? t('NEWS') : type === obsTypes.pews ? t('PEWS Score') : t('GCS Score')}
                </div>
            </div>
        </div>
    );

    const renderPtName = () => {
        return `${props.props.patient?.patient?.familyName
            ? props.props.patient?.patient?.familyName : ''}, ${props.props.patient?.patient?.firstName
            ? props.props.patient?.patient?.firstName.substring(0, 1) : ''}`;
    };

    const renderPtHospitalNo = () => {
        return `${props.props.patient?.patient?.hospitalNumber ? props.props.patient?.patient?.hospitalNumber : 'Not provided'}`;
    };

    const handlePrevStep = () => {
        setIpodStep(iPodStep - 1);
    };

    const handleNextStep = () => {
        setIpodStep(iPodStep + 1);
    };

    const renderActionButton = () => {
        return (
            <Grid container spacing={2} direction="row" justifyContent="flex-start" alignItems="center">
                <Grid item xs={ipodView ? 12 : 6} className={clsx(classes.divRow, isSmallDevice && 'mobile')}>
                    {safetyListButtonInObs &&
                        <div className={classes.divRow} style={{marginLeft: 10, marginTop: 5}}>
                            <AgyleBlockSwitch
                                onChange={setOpenSafetyChecklistAfterObs}
                                value={openSafetyChecklistAfterObs}
                            />
                            <FormLabel style={{marginLeft: 5}}>
                                {t('Open PSC after OBS')}
                            </FormLabel>
                        </div>
                    }

                    {safetyListButtonInObs && type !== obsTypes.neuro &&
                        <div className={classes.divRow} style={{marginLeft: 10, marginTop: 5}}>
                            <AgyleBlockSwitch
                                onChange={setOpenNeuroAfterObs}
                                value={openNeuroAfterObs}
                            />
                            <FormLabel style={{marginLeft: 5}}>
                                {t('Open Neuro after OBS')}
                            </FormLabel>
                        </div>}
                </Grid>

                <Grid item xs={6} md={6}
                      style={{display: 'flex', justifyContent: 'flex-end', gap: 5, alignItems: 'center'}}>
                    <AgyleButton
                        className={ipodView ? classes.obsButtonIpod : classes.obsButton}
                        fullWidth
                        variant="outlined"
                        onClick={showCancelDialog}
                        disabled={disableAction}>
                        {t('Close')}
                    </AgyleButton>

                    <AgyleButton
                        className={ipodView ? classes.obsButtonIpod : classes.obsButton}
                        fullWidth
                        variant="contained"
                        onClick={onSaveObs}
                        disabled={acceptDisabled || disableAction || errorRetro}>
                        {t('Submit')}
                    </AgyleButton>
                </Grid>

                {ipodView &&
                    <Grid item xs={6} md={6}>
                        <ButtonGroup>
                            {(ipodView && type && iPodStep > 0) &&
                                <AgyleButton
                                    className={classes.obsButtonIpod}
                                    fullWidth
                                    variant="contained"
                                    onClick={handlePrevStep}
                                >
                                    {t('Prev')}
                                </AgyleButton>
                            }

                            {(ipodView && type && obsMapper[type][iPodStep]) &&
                                <AgyleButton
                                    className={classes.obsButtonIpod}
                                    fullWidth
                                    variant="contained"
                                    onClick={handleNextStep}
                                >
                                    {t('Next')}
                                </AgyleButton>
                            }
                        </ButtonGroup>
                    </Grid>
                }
            </Grid>
        );
    };

    const handleChangeAccordion = (obsType) => {
        setObservationItemsList(prevState => ({
            ...prevState,
            [obsType]: {
                ...prevState[obsType],
                expanded: !prevState[obsType].expanded,
            },
        }));
    };

    const renderObsComponent = (obsType) => {
        const obj = observationItemsList?.[obsType];
        if (obj?.disabled) return null;

        return (
            <Grid item xs={12} id={obsType} key={obsType} style={{backgroundColor: 'transparent'}}>
                <AgyleAccordion
                    expanded={obj.expanded}
                    onChange={() => handleChangeAccordion(obsType)}
                    label={t(obsSections[obsType]?.description)}
                    addShadow
                    unmountOnExit={false}
                    formBackground={false}
                >
                    {React.createElement(obj.component, {
                        ...localValue[obsType],
                        ...obj.props,
                        type: type,
                        ipodView,
                        ageRangeYears: ageRangeYears,
                        onErrorPicker: setErrorRetro,
                        onChange: (value) => {
                            if (obj.updateRoot) {
                                updateLocalValue(value);
                            } else {
                                updateLocalValue({[obsType]: value});
                            }
                        },
                    })}
                </AgyleAccordion>
            </Grid>);
    };

    const renderObs = (obsType) => {
        if (obsType) {
            let renderedObsComponents = [];

            if (!ipodView) {
                obsMapper[obsType].forEach(obsList => {
                    obsList.forEach((componentName) => {
                        renderedObsComponents.push(renderObsComponent(componentName));
                    });
                });

                renderedObsComponents.push(scoreItem());
            } else {
                if (obsMapper[obsType].length === iPodStep) return scoreItem();

                obsMapper[obsType][iPodStep].forEach((componentName) => {
                    renderedObsComponents.push(renderObsComponent(componentName));
                });
            }
            return renderedObsComponents;
        }
    };

    function getAirType() {
        return localValue.airOxygen?.airType;
    }

    const scoreItem = () => {
        return <Grid item xs={12} id="score" key="score">
            <ObsScore
                painScore={localValue.painScore}
                totalScore={localValue.totalScore}
                prevTotalScore={prevObsStats.totalScore}
                nextObsDate={localValue.nextObsDate}
                prevObsDate={prevObsStats.obsDate}
                allAccepted={allAccepted}
                anyAccepted={anyAccepted}
                riskLevel={localValue.riskLevel}
                prevRiskLevel={prevObsStats.riskScore}
                type={type}
                isNT={isNotTestable}
                ageRangeYears={ageRangeYears}
                startedDate={localValue.startedDate}
                extraOption1={localValue.extraOption1}
                extraOption1Reason={localValue.extraOption1Reason}
                extraOption2={localValue.extraOption2}
                extraOption3={localValue.extraOption3}
                extraOption3Reason={localValue.extraOption3Reason}
                extraOption4={localValue.extraOption4}
                extraOption4Reason={localValue.extraOption4Reason}
                extraOption1Disabled={!dispatch(hasPermission(Permissions.AGYLE_CAN_ESCALATE_OBSERVATION)) || localValue.extraOption1Disabled}
                extraOption2Disabled={!dispatch(hasPermission(Permissions.AGYLE_CAN_ESCALATE_OBSERVATION)) || localValue.extraOption2Disabled}
                extraOption3Disabled={!dispatch(hasPermission(Permissions.AGYLE_CAN_ENTER_YN_SEPSIS)) || localValue.extraOption3Disabled}
                consciousness={localValue.consciousness}
                onChange={(value) => {
                    updateLocalValue({
                        nextObs: value.nextObs,
                        nextObsDate: value.nextObsDate,
                        clinicalResponse: value.clinicalResponse,
                        extraOption1: value.extraOption1,
                        extraOption1Reason: value.extraOption1Reason,
                        extraOption2: value.extraOption2,
                        extraOption3: value.extraOption3,
                        extraOption3Reason: value.extraOption3Reason,
                        extraOption4: value.extraOption4,
                        extraOption4Reason: value.extraOption4Reason,
                    });
                }}
                setAcceptDisabled={setAcceptDisabled}
                overHour={overHour}
                patient={props.patient}
            />
        </Grid>;
    };

    const obsComponents = (
        <Grid container spacing={2}>
            {renderObs(type)}

            <Grid
                item
                xs={12}
                id="buttons"
                sx={{display: {xs: 'block', sm: 'none', md: 'none'}}}
                style={{
                    textAlign: 'right',
                    padding: '0 10px 5px 10px',
                    float: 'right',
                }}
            >
                {renderActionButton()}
            </Grid>
        </Grid>
    );

    return (
        <>
            {/*<AgyleDialog*/}
            {/*    id={'obs-dialog'}*/}
            {/*    open={open}*/}
            {/*    fullScreen={ipodView}*/}
            {/*    width={false}*/}
            {/*    disableActions*/}
            {/*    disableTitle*/}
            {/*    noPadding*/}
            {/*    dividers={false}*/}
            {/*    scroll={'paper'}*/}
            {/*    aria-labelledby="scroll-dialog-title"*/}
            {/*    onClose={showCancelDialog}*/}
            {/*    fullWidth*/}
            {/*>*/}
            <div
                id="scroll-dialog-content"
                style={{padding: 0}}
            >
                <Grid container spacing={0}>
                    <Grid
                        item
                        sx={{display: {xs: 'none', sm: 'none', md: 'block'}}}
                        md={2}
                        className={classes.sectionColumn}
                    >
                        {obsMenuList}
                    </Grid>

                    <Grid
                        item
                        sm={12}
                        md={10}
                        className={classes.observationsColumn}
                    >
                        <div
                            className={clsx(ipodView && classes.observationsContentIpod, classes.observationsContent)}
                        >
                            <div
                                className={(ipodView ? classes.obsScrollIpod : classes.obsScroll) + ' obs-scrollbar scroll-normal-white'}
                            >
                                {obsComponents}
                            </div>
                        </div>
                    </Grid>

                    {/*<Grid*/}
                    {/*    sx={{display: {xs: 'none', sm: 'block'}}}*/}
                    {/*    item*/}
                    {/*    xs={12}*/}
                    {/*    style={{*/}
                    {/*        textAlign: 'right',*/}
                    {/*        paddingRight: 30,*/}
                    {/*        paddingBottom: 5,*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    {renderActionButton()}*/}
                    {/*</Grid>*/}
                </Grid>
            </div>
            {/*</AgyleDialog>*/}

            <MessageBox
                onClose={() => setConfirmDialog(false)}
                title={t('Confirmation')}
                disableSave
                disabled={disableAction}
                message={confirmMessage}
                haveAccept={{yes: t('Yes'), no: t('No')}}
                onAccept={confirmAction}
                open={confirmDialog}
            />

            <Drawer
                container={container}
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                    display: {xs: 'block', sm: 'block'},
                    '& .MuiDrawer-paper': {
                        boxSizing: 'border-box',
                        width: drawerWidth,
                    },
                }}
            >
                test?
                {obsMenuList}
            </Drawer>
        </>
    );
}

export default Observation;
